import _implicitStylesheets from "./stepSection.css";
import _implicitScopedStylesheets from "./stepSection.scoped.css?scoped=true";
import _axBadge from "ax/badge";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 class="title${0}" type-style="display-6"${2}>${"t1"}</h3>`;
const stc0 = {
  classMap: {
    "container": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "header": true
  },
  key: 1
};
const stc2 = {
  attrs: {
    "name": "cta"
  },
  key: 5
};
const stc3 = [];
const stc4 = {
  classMap: {
    "description": true
  },
  attrs: {
    "type-style": "body-3"
  },
  key: 6
};
const stc5 = {
  attrs: {
    "name": "description"
  },
  key: 7
};
const stc6 = {
  classMap: {
    "content-container": true
  },
  key: 8
};
const stc7 = {
  attrs: {
    "name": "content"
  },
  key: 9
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, s: api_slot, h: api_element} = $api;
  return [api_element("div", stc0, [api_element("div", stc1, [$cmp.stepNumber ? api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.stepNumberLabel,
      "variant": "outline",
      "theme": "blue"
    },
    key: 2
  }) : null, $cmp.stepTitle ? api_static_fragment($fragment1, 4, [api_static_part(1, null, api_dynamic_text($cmp.stepTitle))]) : null, api_slot("cta", stc2, stc3, $slotset)]), api_element("span", stc4, [api_slot("description", stc5, stc3, $slotset)]), api_element("div", stc6, [api_slot("content", stc7, stc3, $slotset)])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["content", "cta", "description"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6j6tmntblv4";
tmpl.legacyStylesheetToken = "undefined-_stepSection";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
